import React from 'react';

const ShipmentNotFound = () => (
  <div>
    shipment not found
  </div>
);

export default ShipmentNotFound;
